<template>
  <div id="app">
    <Header :fixedFlag="fixedFlag" :showMenu="showMenu"/>
    <router-view />
    <Footer v-if="showFooter"/>
    <Menu v-if="showMenu"/>
  </div>
</template>

<script>
import Bus from "./bus";
import Header from "../src/components/header.vue"
import Footer from "../src/components/footer.vue"
import Menu from "../src/components/menu.vue"
export default {
  name: "App",
  data() {
    return {
      fixedFlag: true, // 是否默认固定顶部样式
      showFooter: false,
      showMenu: false,
    };
  },
  components: {
    Header,
    Footer,
    Menu
  },
  created() {
    this.fixedFlag = this.$route.fullPath === '/' ? true : false;
    this.showFooter = this.$route.fullPath === '/' ? false : true;
  },
  watch: {
    $route(to, from) {
      this.showFooter = to.fullPath == '/' ? false : true;
      this.fixedFlag  = to.fullPath == '/' ? true : false;
    }
  },
  mounted() {
    Bus.$on("logo-fixed-flag", val => {
      this.fixedFlag = val;
      if (val) {
        this.showFooter = false;
      }
    });
    Bus.$on("show-menu", val => {
      this.showMenu = val;
    });
  },
}
</script>

<style lang="less" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  background: #F0F2F5;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue